import React, {useEffect, useState} from 'react';

import {useChangeContext} from "../../../Hooks/RouteHooks";
import {useSelector} from "react-redux";
import {service as SampleEventPhaseService} from '../../../Services/SampleEventPhaseService';
import {service as SampleEventTypeService} from '../../../Services/SampleEventTypeService';
import {service as ProcedureService} from '../../../Services/ProcedureService';
import {service as EnvironmentalBenefitService} from '../../../Services/EnvironmentalBenefitService';
import {SampleEventIndexPage} from "./SampleEventIndexPage";
import {EventsTableFilter} from "./TableFilter";

export const EventsIndexPage = props => {
    const changeContext = useChangeContext();
    const context = useSelector(state => state.contextState.context);
    
    const [loaded, setLoaded] = useState(null);
    
    
    useEffect(() => {
        Promise.allSettled([
            ProcedureService.PrimeCache(),
            EnvironmentalBenefitService.PrimeCache(),
            SampleEventPhaseService.PrimeCache(),
            SampleEventTypeService.PrimeCache()
        ]).then(() => {
            setLoaded(true);
        });
    }, []);

    return loaded && <SampleEventIndexPage
        context={context}
        onNewClick={() => changeContext({parentProgram: "new"})}
        tableFilter={EventsTableFilter}
    />;
};


